<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <select-box :selects="selects" :post-form.sync="listQuery" @search="fnGetTableLists()" />
        <el-button type="success" @click="fnExport()"> 导出</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <wq-table ref="resumecoursestatusListstable" :local-data="resumeLists" :other-query="listQuery">
        <el-table-column label="店铺" prop="shop_name" align="center" />
        <el-table-column label="学员姓名" prop="real_name" align="center" />
        <el-table-column label="学员ID" prop="cuid" align="center" />
        <el-table-column label="状态" prop="status_name" align="center" />
        <el-table-column label="复课时间" prop="create_time" align="center" />
        <el-table-column label="停课时间" prop="last_stop_date" align="center" />
        <el-table-column label="停课天数" prop="stop_num" align="center" />

        <el-table-column label="截图" align="center">
          <template slot-scope="{row}">
            <el-image v-for="image in row.audit_picture" :key="image" style="width: 30px;float:left;margin-right: 5px;" :src="image" :preview-src-list="row.audit_picture" />
          </template>
        </el-table-column>
        <el-table-column label="复课原因" prop="remark" align="center" />
        <el-table-column label="校长审核" prop="remark" align="center">
          <template slot-scope="{row}">
            <span>{{ row.extra && row.extra.audit_remark ? row.extra.audit_remark : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总部评价" prop="remark" align="center">
          <template slot-scope="{row}">
            <span>{{ row.extra && row.extra.admin_remark ? row.extra.admin_remark : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="remark" align="center">
          <template slot-scope="{row}">
            <el-button v-if="row.audit_status < 4" type="primary" size="small" @click="fnUpdate(row)">审核结果</el-button>
          </template>
        </el-table-column>

      </wq-table>

    </div>
    <el-dialog width="60%" :close-on-click-modal="false" title="审核结果" :visible.sync="bUpdate">
      <form-box label-width="120px" :forms="forms" :post-form="reviewPostForm" @submit="fnSubmit">
        <template v-slot:status="{currentForm, item}">
          <el-radio v-model="currentForm[item.bindValue]" label="4">合格</el-radio>
          <el-radio v-model="currentForm[item.bindValue]" label="5">不合格</el-radio>
          <el-radio v-model="currentForm[item.bindValue]" label="6">待复核</el-radio>

        </template>
      </form-box>
    </el-dialog>
  </div>

</template>
<script>

const defaultReviewPostForm = {
  status: '',
  id: '',
  remark: ''
}
const statusMap = [
  { id: 0, name: '校长待审核' },
  { id: 1, name: '校长审核成功' },
  { id: 2, name: '校长审核失败' },
  { id: 4, name: '图片合格' },
  { id: 5, name: '图片不合格' },
  { id: 6, name: '待复核' }
]

import Tool from '@/assets/js/tool.js'
import FormBox from '@/components/FormBox'
import SelectBox from '@/components/SelectBox'
import WqTable from '@/components/WqTable'

export default {
  name: 'ResumeCourseStatusLists',
  components: {
    WqTable,
    SelectBox,
    FormBox
  },

  data() {
    return {
      lists: [],
      listQuery: {
        begin_time: '',
        status: 1,
        end_time: '',
        times: [],
        shop_id: '',
        child_id:'',

      },
      forms: [
        { type: 'textarea', bindValue: 'remark', label: '备注', require: true },
        { type: 'custom', component: 'radio', bindValue: 'status', label: '是否合格', require: true }
      ],
      bUpdate: false,
      resumeLists: [],
      reviewPostForm: Object.assign({}, defaultReviewPostForm),
      selects: [
        { type: 'daterange', bindValue: 'times', mapValue: ['begin_time', 'end_time'] },
        { type: 'select', columns: statusMap, bindValue: 'status', placeholder: '请选择状态' },
        { type: 'select', dataFunc: this.$http.getMyShopList, bindValue: 'shop_id', placeholder: '请选择校区' },
        { type: 'input', bindValue: 'child_id', placeholder: '学员ID' },
      ]
    }
  },
  created() {
    this.fnGetTableLists()
  },
  methods: {
    fnGetTableLists() {
      this.$http.getReviewOfResumptionOfClasses(this.listQuery).then(res => {
        res.data.forEach(ele => {
          console.log(Tool.findIndexInArryByKeyVal(statusMap, 'id', ele.audit_status))
          ele.status_name = statusMap[Tool.findIndexInArryByKeyVal(statusMap, 'id', ele.audit_status)].name
          if (ele.extra && ele.extra.audit_picture) {
            ele.audit_picture = ele.extra.audit_picture.split(',')
          }
        })
        this.resumeLists = res.data
      })
    },
    fnUpdate(row) {
      this.reviewPostForm = Object.assign({}, defaultReviewPostForm, { id: row.id })
      this.bUpdate = true
    },
    fnSubmit(postForm) {
      this.$http.changeReviewOfResumptionOfClassesStatus(postForm).then(res => {
        this.bUpdate = false
        this.fnGetTableLists()
      })
    },
    fnExport() {
      Tool.exportExcelElTable('复课记录', this.$refs['resumecoursestatusListstable'])
    }
  }
}
</script>
<style lang="scss">
.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
